module.exports = {
  DEFAULT_LANGUAGE: 'DEFAULT_LANGUAGE',
  TABLE_CHARGES: 'TABLE_CHARGES',
  EAT_IN_TAX: 'EAT_IN_TAX',
  TAKE_AWAY_TAX: 'TAKE_AWAY_TAX',
  KIDS_DISCOUNT: 'KIDS_DISCOUNT',
  DAILY_STOCK_UPDATE: 'DAILY_STOCK_UPDATE',
  DISPLAY_ITEM_AMOUNT_PER_PORTION: 'DISPLAY_ITEM_AMOUNT_PER_PORTION',
  DISPLAY_ITEM_COOKING_TIME: 'DISPLAY_ITEM_COOKING_TIME',
  DISPLAY_ITEM_CALORIES: 'DISPLAY_ITEM_CALORIES',
  DISPLAY_ITEM_TAKE_OUT: 'DISPLAY_ITEM_TAKE_OUT',
  PRICE_ROUNDING: 'PRICE_ROUNDING',
  ROUND_UP: 'ROUND_UP',
  ROUND_DOWN: 'ROUND_DOWN',
  ROUND_OFF: 'ROUND_OFF',
  PRICE_DISPLAY_OPTION: 'PRICE_DISPLAY_OPTION',
  PRICE_EXCLUDING_TAX: 'PRICE_EXCLUDING_TAX',
  PRICE_INCLUDING_TAX: 'PRICE_INCLUDING_TAX',
  BOTH_INCL_EXCL_TAX: 'BOTH_INCL_EXCL_TAX',
};
